import { useState, useCallback } from 'react';

export interface AppSettings {
  defaultPageSize: 10 | 20 | 50;
  autoRefreshInterval: 0 | 30 | 60 | 300; // seconds; 0 = off
  compactMode: boolean;
}

const STORAGE_KEY = 'twin_admin_settings';

const DEFAULTS: AppSettings = {
  defaultPageSize: 20,
  autoRefreshInterval: 0,
  compactMode: false,
};

function load(): AppSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULTS;
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return DEFAULTS;
  }
}

function save(settings: AppSettings) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export function useSettings() {
  const [settings, setSettingsState] = useState<AppSettings>(load);

  const updateSettings = useCallback((patch: Partial<AppSettings>) => {
    setSettingsState(prev => {
      const next = { ...prev, ...patch };
      save(next);
      return next;
    });
  }, []);

  const resetSettings = useCallback(() => {
    save(DEFAULTS);
    setSettingsState(DEFAULTS);
  }, []);

  return { settings, updateSettings, resetSettings };
}
